__turbopack_context__.v({
  "button": "Button-module__n1HeCq__button",
  "buttonActive": "Button-module__n1HeCq__buttonActive",
  "buttonClickable": "Button-module__n1HeCq__buttonClickable",
  "buttonDanger": "Button-module__n1HeCq__buttonDanger",
  "buttonDangerGhost": "Button-module__n1HeCq__buttonDangerGhost",
  "buttonDangerSecondary": "Button-module__n1HeCq__buttonDangerSecondary",
  "buttonDisabled": "Button-module__n1HeCq__buttonDisabled",
  "buttonExpandable": "Button-module__n1HeCq__buttonExpandable",
  "buttonGhost": "Button-module__n1HeCq__buttonGhost",
  "buttonIconOnly": "Button-module__n1HeCq__buttonIconOnly",
  "buttonNormal": "Button-module__n1HeCq__buttonNormal",
  "buttonNormalCount": "Button-module__n1HeCq__buttonNormalCount",
  "buttonPrimary": "Button-module__n1HeCq__buttonPrimary",
  "buttonPulsing": "Button-module__n1HeCq__buttonPulsing",
  "buttonRounded": "Button-module__n1HeCq__buttonRounded",
  "buttonSecondary": "Button-module__n1HeCq__buttonSecondary",
  "buttonSmall": "Button-module__n1HeCq__buttonSmall",
  "buttonSmallCount": "Button-module__n1HeCq__buttonSmallCount",
  "buttonSuccess": "Button-module__n1HeCq__buttonSuccess",
  "buttonTiny": "Button-module__n1HeCq__buttonTiny",
  "buttonTinyCount": "Button-module__n1HeCq__buttonTinyCount",
  "buttonWarning": "Button-module__n1HeCq__buttonWarning",
  "buttonWhite": "Button-module__n1HeCq__buttonWhite",
  "buttonWhiteFill": "Button-module__n1HeCq__buttonWhiteFill",
  "button__count": "Button-module__n1HeCq__button__count",
  "button__flair": "Button-module__n1HeCq__button__flair",
  "button__notificationCount": "Button-module__n1HeCq__button__notificationCount",
  "subtleRotate": "Button-module__n1HeCq__subtleRotate",
});
